import styled from "styled-components";

export const NavbarContainer = styled.nav`
  width: 100%;
  /* height: 72px; */
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 56px;
  @media (max-width: 1024px) {
    padding-top: 40px;
  }
  @media (max-width: 480px) {
    padding-top: 24px;
  }
`;

export const LogoContainer = styled.div`
  width: 25%;
  /* height: 72px; */
  display: flex;
  align-items: center;
  @media (max-width: 850px) {
    width: 20%;
  }
  @media (max-width: 685px) {
    width: 15%;
  }
  h2 {
    font-size: 3.2rem;
    color: var(--logo-color);
    font-family: Peyda;
    font-weight: 900;
    span {
      color: var(--primary-color);
    }
  }
`;

export const MenuContainer = styled.ul`
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10rem;
  @media (max-width: 1750px) {
    width: 60%;
    padding: 0 8rem;
  }
  @media (max-width: 1560px) {
    width: 70%;
    padding: 0 6rem;
  }
  @media (max-width: 1440px) {
    width: 80%;
    padding: 0 4rem;
  }
  @media (max-width: 1024px) {
    display: none;
  }
`;

export const NavItem = styled.li`
  cursor: pointer;
  &:first-child a {
    color: var(--logo-color);
  }
  a {
    color: var(--nav-color);
    position: relative;
    font-weight: 500;
    font-size: 1.6rem;
    font-family: Peyda;
    font-style: normal;
    @media (max-width: 740px) {
      font-size: 1.4rem;
    }
    &::after {
      position: absolute;
      content: "";
      width: 0;
      height: 3px;
      background: var(--primary-color);
      left: 50%;
      bottom: -15px;
      transition: all 0.4s ease-in-out;
    }
  }
  &:hover a::after {
    width: 100%;
    left: 0;
  }
`;

export const LoginButtonHeader = styled.div`
  width: 25%;
  display: flex;
  justify-content: flex-end;
  button {
    box-shadow: 0px 33.3681px 66.7361px rgba(10, 192, 94, 0.1);
  }
  @media (max-width: 1200px) {
    width: 20%;
  }
  @media (max-width: 600px) {
    width: 40%;
  }
  @media (max-width: 480px) {
    position: absolute;
    top: 353px;
    right: 15%;
    width: 130px !important;
    display: none;
  }
  @media (max-width: 360px) {
    right: 5%;
  }
`;
